<template>
  <div id="app">
    <branch-header></branch-header>
    <router-view/>
    <navFooter></navFooter>
    <div class="empty-footer-div"></div>
  </div>
</template>

<script>
import BranchHeader from '@/components/BranchHeader'
import navFooter from '@/components/navFooter'
export default {
  name: 'App',
  data () {
    return {
      ico:'',
      short_name:''
    }
  },
  methods:{
    getIco(){
      this.$axios.post(this.api.groupIndex,{},res =>{
          this.ico=res.data.logo;

          this.$store.dispatch('setIcpRecord',res.data.icp_record);
          this.$store.dispatch('setPoliceRecord',res.data.police_record);
          this.$store.dispatch('setPoliceRecordNumber',res.data.police_record_number);

          var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
          link.type = 'image/x-icon';
          link.rel = 'shortcut icon';
          link.href = this.ico;
          document.getElementsByTagName('head')[0].appendChild(link);
        }); 
    }
  },
  components: {
    navFooter,
    BranchHeader
  },
  created(){
    this.short_name=this.$route.params.short_name;
    sessionStorage.setItem('english_short_name',this.short_name);
    this.getIco();
  },
  watch: {
      $route(to,from){
        this.short_name=to.params.short_name;
        sessionStorage.setItem('english_short_name',this.short_name);
        this.getIco();
      }
  },
}
</script>

<style>
html,body{height:100%;}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height:100%;
  position:relative;/*底部元素的高度，具体有略微差别*/
}
.empty-footer-div{height:240px;}
.toolbar{text-align: center;position: relative;}
.header-empty{
  height:140px;
}
.el-pagination .el-pager li.active {
    color: #fff !important;
    background-color: #4A90E2 !important;
    border-radius: 5px;
    min-width: 28px}

</style>



// WEBPACK FOOTER //
// src/App.vue